import { render, staticRenderFns } from "./CRBulkInput.vue?vue&type=template&id=22c3ca3e&scoped=true"
import script from "./CRBulkInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CRBulkInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CRBulkInput.vue?vue&type=style&index=0&id=22c3ca3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c3ca3e",
  null
  
)

export default component.exports